module.exports = __webpack_public_path__ + "img/aston-blog-list.c59941a3.jpg";